import { render, staticRenderFns } from "./addEventDialog.vue?vue&type=template&id=72dd0d2a&scoped=true&"
import script from "./addEventDialog.vue?vue&type=script&lang=js&"
export * from "./addEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./addEventDialog.vue?vue&type=style&index=0&id=72dd0d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd0d2a",
  null
  
)

export default component.exports